module.exports = __webpack_public_path__ + "img/montreal.95c59f80.jpeg";